import { DealSummary } from './DealSummary'

export default DealSummary
